import {Text, VStack} from '@chakra-ui/react'
import React from 'react'
import Icon from '../../components/cms/icon'
import Copy from '../../components/cms/copy'
import Heading from '../../components/cms/heading'
import PropTypes from 'prop-types'
import {COLOR_SCHEMES} from '../../constants'

const Statement = ({headline, copy, icon, colorScheme = 'black'}) => {
    const {headline: headlineColor} = COLOR_SCHEMES[colorScheme]

    return (
        <VStack gap={8} align="center" bg="bg-darkgrey-1" p={16} borderRadius={'2rem'}>
            <Icon {...icon}></Icon>
            <Text
                color={headlineColor}
                pt={4}
                textStyle="Regular 2XLarge"
                alignment={headline.alignment}
            >
                {headline.text}
            </Text>

            {copy && <Copy {...copy} alignment="center" colorScheme={colorScheme} />}
        </VStack>
    )
}

Statement.propTypes = {
    colorScheme: PropTypes.string,
    headline: PropTypes.string,
    icon: PropTypes.object,
    copy: PropTypes.object
}

const Statements = ({statements, colorScheme, heading, headingLevel}) => {
    const {bg} = COLOR_SCHEMES[colorScheme]

    return (
        <VStack
            as="section"
            backgroundColor={bg}
            pt={14}
            pb={6}
            px={6}
            align={'start'}
            gap={12}
            width={'100%'}
        >
            <Heading {...heading} headingLevel={headingLevel} />
            {statements.map((statement, index) => (
                <Statement key={index} {...statement} />
            ))}
        </VStack>
    )
}

Statements.propTypes = {
    colorScheme: PropTypes.string,
    headingLevel: PropTypes.number,
    heading: PropTypes.object,
    statements: PropTypes.array
}

export default Statements
